export enum SearchEvents {
    CLEAR = "SEARCH_CLEAR",
    UPDATE = "SEARCH_UPDATE",
    SEARCH = "SEARCH_SEARCH", // lol
    SETUP = "SEARCH_SETUP",
    CHANGE_SEARCH_LEVEL = "SEARCH_CHANGE_SEARCH_LEVEL",
    CHANGE_SAVE_LOCATION = "SEARCH_CHANGE_SAVE_LOCATION",
    BULK = "SEARCH_BULK_REQUEST",
}

export enum SearchIndexes {
    PRODUCT_NAME,
    PRODUCT_BARCODE,
    CUSTOMER_NAME,
    CUSTOMER_PHONE,
    CUSTOMER_EMAIL,
    CUSTOMER_COMPANY,
    CUSTOMER_CODE,
    PROMOTION_NAME,
    PRICE_LIST_NAME,
}

export enum SearchIndexGroups {
    PRODUCTS,
    CUSTOMERS,
    PROMOTIONS,
    PRICE_LISTS,
}

export interface SearchSetupMessage {
    message: {
        searchLevels: {
            products: string;
            customers: string;
        };
        saveLocation: SearchSaveLocation;
    };
}

export type SearchSaveLocation = "indexeddb" | "none";
